/**
 * No Undo: removal is a hard delete with no soft-delete window (see
 * [[project_workspace_members]]).
 */
import React from "react";
import MajorToast from "../../component/Toast/MajorToast";

const AUTO_DISMISS_MS = 6000;

const MemberRemovedToast = ({ email, onDismiss }) => (
  <MajorToast
    title="Member removed"
    text={email ? `${email} no longer has access to this workspace.` : "They no longer have access to this workspace."}
    duration={AUTO_DISMISS_MS}
    onDismiss={onDismiss}
  />
);

export default MemberRemovedToast;
